export const DataFiscal = ({provider}) => {
    return (
        <div className="section__datafiscal">
            <a href={provider} target="_blank" rel="noreferrer">
                <img src="./assets/data_fiscal.webp" alt="Data Fiscal" />
            </a>
        </div>
    )
}